module.exports = __webpack_public_path__ + "img/pdf-file.aac2ff4e.svg";